<ng-content></ng-content>
<ion-button class="toggle-password-button" color="medium" fill="clear" slot="end"
  (click)="toggle()">
  <ion-icon slot="icon-only"
    [name]="isVisible ? 'eye' : 'eye-off'">
  </ion-icon>
</ion-button>
